
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Eyres_Brooks_classification_of_scapular_coracoid_process',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Orthopaedics/Eyres_Brooks_classification_of_scapular_coracoid_process.vue